import { createSelector } from 'reselect';

// selectors
const getTickets = (state) => state?.tickets || {};
const getDisableTicketLink = (state) => state?.config?.disableTicketLink;
const getLoading = (state) => state.loading?.isLoading;
const getAbstractGameState = (state) => state?.gumbo?.gameData?.status?.abstractGameState || '';

// reselect function
export const getTicketsSelector = createSelector(
    [getTickets, getLoading, getDisableTicketLink, getAbstractGameState],
    (tickets, isLoading, disableTicketLink, abstractGameState) => (
        {
            ...tickets,
            isLoading,
            disableTicketLink,
            abstractGameState
        }
    )
);
